import Vue from "vue"

Vue.filter('lineBreak', function (text, maxLength) {
    if (!text) return text;
    let result = '';
    let lines = text.split('');
    for (let i = 0; i < lines.length; i++) {
        if (i > 0 && i % maxLength === 0) {
            result += '<br>';
        }
        result += lines[i];
    }

    return result;
});
